import React from 'react'

export const WelcomePage = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '70vh',
        width: '100%',
      }}
    >
      <h1>Welcome to the user page!</h1>
    </div>
  )
}
